import React from 'react';
import { useLocation } from '@reach/router';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import { getSandboxOptions } from '../../../../utils/helper-functions';
import { GTM_ID } from '../../../../common/constants/gtmIds';
import { H2Atom, PAtom } from '../../atoms/text-atoms/text-atoms';
import { IframeElementProps } from './iframe-element.types';
import { sectionTitleBorder } from '../../mixins';

const IframeElement: React.FC<IframeElementProps> = ({
  titleCmsOnly,
  title,
  description,
  url,
  isFullWidth,
  className,
}) => {
  const location = useLocation();
  const queryString = location.search;
  if (url) {
    const isEligibleForQueryParams = url.includes('qualtrics.com');
    const iframeSrc =
      isEligibleForQueryParams && queryString ? `${url}${queryString}` : url;
    return (
      <div className={className}>
        {title && <H2Atom>{title}</H2Atom>}
        {description && <PAtom>{description}</PAtom>}
        <iframe
          title={title ? title : 'Embedded IFrame'}
          src={iframeSrc}
          sandbox={getSandboxOptions(url)}
          data-testid="iframe-element"
          data-gtm-id={GTM_ID.IFRAME_ELEMENT}
          className={className}
          allowFullScreen={true}
        />
      </div>
    );
  } else {
    console.warn(`iframe-element called with missing url: ${titleCmsOnly}`);
    return null;
  }
};

const StyledIframeElement = styled(IframeElement)`
  ${H2Atom} {
    margin-bottom: ${vars.spacingM};
    ${({ colour }) => sectionTitleBorder(colour)};

    ${({ isFullWidth }) =>
      isFullWidth &&
      `
      padding: 0 1.2rem;
    `}
  }
  ${PAtom} {
    margin-bottom: ${vars.spacingM};

    ${({ isFullWidth }) =>
      isFullWidth &&
      `
      padding: 0 1.2rem;
    `}
  }
  iframe {
    margin-top: 0;
    margin-bottom: 0;
    border-radius: 8px;
    border: none;
    width: 100%;

    ${({ isFullWidth }) =>
      isFullWidth &&
      `
      border-radius: 0;
    `}
  }

  height: 100%;
`;

export default StyledIframeElement;
